import View from "../framework/view";
import Server from "../server";
import {App} from "../app/app";
import template from "../../pugc/add-payment";
import {Order} from "../bo/order";
import {formToJson, renderDollars} from "../misc/utils";
import {todayJSONDate} from "../misc/dates";

export class AddPaymentView extends View {

    static classname = "add-payment-view";

    private readonly server = Server.instance();

    private app: App;

    private totalprice: number | undefined;

    constructor(app: App) {
        super(AddPaymentView.classname);
        this.app = app;
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            totalprice: this.totalprice,
        };

        const out = this.pug(template, data);

        out.find("form.with-validation").validate({
            rules: {
                price: {
                    required: true,
                },
                src: {
                    required: true
                }
            }
        });

        return out;
    }

    toOrder() : Order | undefined {
        const form = this.elt().find("form.add-payment-form");

        if (! form.valid()) {
            return undefined;
        }

        const data : any = {};
        formToJson(form, data);

        const dollars = Number(data.price);

        const name = data.name || "";
        const bits = [
            name,
            data.src,
            renderDollars(dollars)
        ];

        const desc = bits.filter((x) => x).join(" ");

        const order : Order = {
            lineItems: [
                {
                    name: desc,
                    price: dollars
                }
            ],
            orderHistory: [
                {
                    createdTs: new Date().getTime(),
                    newStatus: "New",
                },
                {
                    createdTs: new Date().getTime(),
                    newStatus: "Paid",
                    createdBy: data.src
                },
                {
                    createdTs: new Date().getTime(),
                    newStatus: "Printed",
                },
                {
                    createdTs: new Date().getTime(),
                    newStatus: "Made",
                }
            ],
            deliveryDate: todayJSONDate(),
        };

        // @ts-ignore
        order.buyerInfo = {
            firstName: data.src,
            lastName: "",
        };

        return order;
    }

    addOrder() {
        const order = this.toOrder();
        if (! order) {
            return;
        }
        const add_ = this.server.addOrder(order);
        add_.then(() => {
            this.app.gotoUrl("/orders/today/All");
        });
    }

}

View.on(
    "." + AddPaymentView.classname,
    "click",
    ".add-payment",
    function(that: AddPaymentView, event, elt) {
        event.preventDefault();
        that.addOrder();
    });
